module.exports = __webpack_public_path__ + "assets/img/i7.4306960d.png";